import { useEffect, useState } from 'react';
import { ConfigurationType } from 'web-library/models/DropDown';
import { usePostSearchApprovers } from '../../../api-refactored/user-group-access-configuration/usePostSearchApprovers';

interface ApproverMeta {
  functionModule: string;
  functionName: string;
}

export const useApproverList = ({ functionModule, functionName }: ApproverMeta) => {
  const {
    mutate: mutatePostSearchApprovers,
    data: approverList,
    isLoading,
  } = usePostSearchApprovers({});

  const [isApprover, setIsApprover] = useState(false);

  useEffect(() => {
    mutatePostSearchApprovers({
      functionModule,
      functionName,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setIsApprover, mutatePostSearchApprovers]);

  return {
    isApprover,
    approverList,
    isLoading,
  };
};

export const mapApproversToDropdown = (data?: ConfigurationType[]) => {
  if (data === undefined) {
    return [];
  }

  return data?.map((a) => ({
    code: a.code,
    description: a.description,
  }));
};
